import { render, staticRenderFns } from "./user_home_tasknum.vue?vue&type=template&id=321f8ad2&scoped=true&"
import script from "./user_home_tasknum.vue?vue&type=script&lang=js&"
export * from "./user_home_tasknum.vue?vue&type=script&lang=js&"
import style0 from "./user_home_tasknum.vue?vue&type=style&index=0&id=321f8ad2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321f8ad2",
  null
  
)

export default component.exports